import { IFieldValidationResult } from 'src/app/interfaces/zc-validation-result.interface';
import { IBaseMutableModel } from 'src/app/interfaces/base-mutable-model.interface';
import { ICalibrationSetModel } from 'src/app/interfaces/calibration-set-model.interface';
import { IBaseTableCell } from 'src/app/interfaces/tables/cells/base-table-cell-interface';
import { IUsesTableColumn } from 'src/app/interfaces/tables/cells/uses-table-column.interface';
import { CalibrationUsesValModel } from '../calibrations/calibration-uses-val.model';
import * as _ from 'lodash';

export class UsesTableColumn implements IUsesTableColumn {
    calibrationSet: ICalibrationSetModel<any>;
    uses: Map<string, IBaseTableCell<ZoneIQCalibration.ICalibrationUsesVal>>;
    value?: IBaseMutableModel<any>;
    usesValues: IBaseTableCell<ZoneIQCalibration.ICalibrationUsesVal>[];

    constructor(
        calibrationSet: ICalibrationSetModel<any>,
        uses: Map<string, IBaseTableCell<ZoneIQCalibration.ICalibrationUsesVal>>
    ) {
        this.calibrationSet = calibrationSet;
        this.uses = uses;
        this.usesValues = Array.from(uses.values());
    }

    getValidationResults(ignoreRequiredFields?: boolean): { [property: string]: IFieldValidationResult } {
        const result: { [property: string]: IFieldValidationResult } = {};
        this.usesValues.forEach(usesValue => {
            const value = (usesValue.value as any) as CalibrationUsesValModel;
            result[`${value.currentState.Id ? value.currentState.Id : 'new'}-${_.get(value, 'usesLabel.Id')}`] = {
                ignoreRequiredFields,
                isOriginalState: !value.isChanged,
                isValid: value.getCombinedValidationResult(this.calibrationSet, ignoreRequiredFields),
                label: _.get(value, 'usesLabel.extendedLabel')
            };
        });
        return result;
    }
}
